import React from "react";
import "../footer/footer.scss"

const Footer = () => {
    return (
        <footer className="footer">
            
        </footer>
    )
};

export default Footer